var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.15078,
    y: 6.85977,
    width: 18.1756,
    height: 11.277,
    rx: 0.65,
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81387 13.004C5.81387 11.2954 7.20071 9.90859 8.90927 9.90859C10.6178 9.90859 12.0047 11.2954 12.0047 13.004C12.0047 14.7126 10.6178 16.0994 8.90927 16.0994C7.20071 16.0994 5.81387 14.7126 5.81387 13.004Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.473 13.004C14.473 11.2954 15.8599 9.90859 17.5684 9.90859C19.277 9.90859 20.6638 11.2954 20.6638 13.004C20.6638 14.7126 19.277 16.0994 17.5684 16.0994C15.8599 16.0994 14.473 14.7126 14.473 13.004Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14486 13.0036C7.14486 12.0299 7.93521 11.2396 8.90888 11.2396C9.88255 11.2396 10.6729 12.0299 10.6729 13.0036C10.6729 13.9773 9.88255 14.7676 8.90888 14.7676C7.93521 14.7676 7.14486 13.9773 7.14486 13.0036Z",
    fill: "#00C65E",
    stroke: "#00C65E",
    strokeWidth: 0.479178
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.804 13.0036C15.804 12.0299 16.5944 11.2396 17.5681 11.2396C18.5417 11.2396 19.3321 12.0299 19.3321 13.0036C19.3321 13.9773 18.5417 14.7676 17.5681 14.7676C16.5944 14.7676 15.804 13.9773 15.804 13.0036Z",
    fill: "#00C65E",
    stroke: "#00C65E",
    strokeWidth: 0.479178
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1927 8.4945C20.1927 8.30211 20.349 8.14584 20.5414 8.14584C20.7338 8.14584 20.89 8.30211 20.89 8.4945C20.89 8.6869 20.7338 8.84317 20.5414 8.84317C20.349 8.84317 20.1927 8.6869 20.1927 8.4945Z",
    fill: "#00C65E",
    stroke: "#00C65E",
    strokeWidth: 0.479178
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2581 8.4945C18.2581 8.30211 18.4144 8.14584 18.6068 8.14584C18.7992 8.14584 18.9555 8.30211 18.9555 8.4945C18.9555 8.6869 18.7992 8.84317 18.6068 8.84317C18.4144 8.84317 18.2581 8.6869 18.2581 8.4945Z",
    fill: "#00C65E",
    stroke: "#00C65E",
    strokeWidth: 0.479178
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.786ef97f62ac1369b35169db61a53ec3.svg";
export { ForwardRef as ReactComponent };